import { createContext } from 'react';

export default createContext({
  hideHeader: true,
  setHideHeader: () => {},
})
